import axios from "axios";
import { CancellationInfoRequest, CancelScenario } from "redmond";

import { config } from "../../config";
import { getGroundChangeInfoPath } from "../paths";

/**
 * @description get cancellation policy by bookingId
 * @param {CancellationInfoRequest} req Contains the reservation id
 * @return {CancelScenario} The cancellation info for the reservation passed in
 */
const getGroundChangeInfo = (
  req: CancellationInfoRequest
): Promise<CancelScenario> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(getGroundChangeInfoPath, req, {
        baseURL: config.baseURL,
      });

      resolve(res.data.value);
    } catch (e) {
      reject(e);
    }
  });

export default getGroundChangeInfo;
